import { BrandColors } from '../theme';

export const avatarTokens = {
    root: {
        fontSize: '1rem',
        background: BrandColors.surface[100],
        color: BrandColors.primary[500],
        borderRadius: '50%',
    },
    group: {
        borderColor: BrandColors.surface[0],
    },
};
